import React from "react";
import { Form, Space, Card, List, Tag, Select, InputNumber, Row } from "antd";
import {    
    MinusCircleOutlined,
  } from '@ant-design/icons';
import ColorButton from "../../common/ColorButton";
import { SUCCESS_COLOR } from "../../constants/color";
import _ from "lodash";
import { formatComma, toFixed } from "../../frameworks/Util";
import { GET, POST } from "../../frameworks/HttpClient";
import { URL_CHEMICAL, URL_LAB } from "../../constants/urls";
import useDropdownItem from "../../common/useDropdownItem";
import { LAB_ACTION } from "../../constants/string";
import ErrorMessages from '../../common/ErrorMessages'
import ReportButton from "../common/ReportButton";
import { URL_REPORT } from '../../constants/urls';

const AddChemicalCard = React.forwardRef((props, ref) => {
  const { order } = props;
  const [target, setTarget] = React.useState(order);
  const [form] = Form.useForm();
  const [errorMessages, setErrorMessages] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [chemicalTankOptions, setChemicalTankOptions] = React.useState();
  const [chemicalLotOptions, setChemicalLotOptions] = React.useState();
  const [debouncedLot, setDebouncedLot] = React.useState('');
  const [debouncedTank, setDebouncedTank] = React.useState('');

  const [debouncedMeter, setdebouncedMeter] = React.useState('');
  const debounceMeter = React.useCallback(_.debounce((_searchVal) => { setdebouncedMeter(_searchVal) }, 800), []);
  const meterDropdown = useDropdownItem({ url: URL_CHEMICAL.METER, label: 'name', value:'id', pagination: true, params: { page_size: 999, name : debouncedMeter } })

  const debounceLot = React.useCallback(_.debounce((_searchVal) => { setDebouncedLot(_searchVal) }, 800), []);
  const debounceTank = React.useCallback(_.debounce((_searchVal) => { setDebouncedTank(_searchVal) }, 800), []);

  const handleFillButton = async(fields, id) => {
    setErrorMessages(null)
    setLoading(true);
    try { 
      //ValidateData
      if(fields){
        const checkValue = await form.getFieldValue(fields) || [];
        const paths = checkValue.map((_, index) => [fields, index, 'amount']);
        const pathsMeter = checkValue.map((_, index) => [fields, index, 'meter']);
        await form.validateFields(paths);
        await form.validateFields(pathsMeter);
      }

      const data = await form.getFieldValue(fields)
      data.map((item) => {
          item['stock_ref'] = item.lot ? item.lot : item.stock ? item.stock : null
          // item['meter'] = item.meter ? item.meter : null
          // delete item['meter']
          delete item['stock']
          delete item['lot']
        }
      )
      await POST(`${URL_LAB.LAB_INPUT}${id}/${LAB_ACTION.COMPLETE}/`, {refs : data})
      updateData();
      meterDropdown.fetchOptions();
    } catch (error) {
        setErrorMessages(_.get(error, error.message ? 'message' : 'errorMessages' , null));
    } finally{
      setTimeout(() => {
        setLoading(false);
      }, 500)
      
    }
  }
  
  const handleRevertButton = async(item) => {
    setLoading(true);
    setErrorMessages(null)
    try {
      await POST(`${URL_LAB.LAB_INPUT}${item.id}/${LAB_ACTION.REVERT}/`, {chemical : item.chemical, order : target.id})
      const data = form.getFieldValue(item.chemical)
      const newData = data.map((item) => {
        return { ...item, meter : null, currentMeter: null, endMeter: null }
      })
      form.setFieldValue(item.chemical, newData);
      meterDropdown.fetchOptions();
    } catch (error) {
      setErrorMessages(error.errorMessages)
    } finally{
      setTimeout(() => {
        setLoading(false);
      }, 500) 
    }
    updateData();
  }

  const handleAddItem = (name) => {
    const list = form.getFieldValue(name) || [];
      form.setFieldsValue({ [name] : [...list, { stock: null, lot: null, meter: null, amount : null }] });
  };

  const renderInputs = async(data) => {
    const inputs = data.inputs
    inputs.map((input) => {
      if(input.refs.length === 0){
        return;
      } else {
        const data = input.refs.map((ref) => {
          return {stock : ref.stock_ref, lot : ref.stock_ref, meter : ref.meter, amount : Number(ref.amount), has_meter : ref.meter ? true : false , currentMeter : ref.start, endMeter : ref.end}
        })
        form.setFieldValue(input.chemical, data)
      }
    })
  };

  const updateData = async() => {
    try {
      const response = await GET(`${URL_LAB.LAB_ORDER}${order.id}`)
      setTarget(response.data);
    } catch (error) {
      setErrorMessages(error.errorMessages)
    }
  }

  const fetchChemicalLot = async() => {
    setErrorMessages(null)
      try {
        const params = {lot_no : debouncedLot, tank_name : debouncedTank}
        const response = await GET(URL_CHEMICAL.QUALITY_CHEMICAL_TANK_TRANSACTION, {is_closed : false, page_size: 999, ...params})

        //Options Lot
        const optionsLotData = response.data.results.map((item) => {
          return({ label : `${item.lot_no} - ${formatComma(item.remain_amount)}`, value : item.id, ...item})
        })
        setChemicalLotOptions(optionsLotData)
        
        //Options Tank
        const optionsTankData = response.data.results.map((item) => {
          return({ label : `${item.tank_name} - [${item.lot_no}]`, value : item.id, ...item})
        })
        setChemicalTankOptions(optionsTankData)

      } catch (error) {
        setErrorMessages(error.setErrorMessages)
      }
  }

  React.useEffect(() => {
    if(target){
      renderInputs(target)
      fetchChemicalLot()
    }
  },[target])

  React.useEffect(() => {
    fetchChemicalLot()
  },[debouncedLot, debouncedTank])

  React.useEffect(() => {
    meterDropdown.fetchOptions();
  },[debouncedMeter])

  return(
    <>
    <ErrorMessages message={errorMessages}/>
    <List
      dataSource={_.get(target, 'inputs', [])}
      renderItem={(item) => (
        <>
        <List.Item>
        <Card 
          size="small"
          style={{ width : '100%'}}
          title={<>{item.chemical} <Tag color="orange" style={{  marginLeft : 10 }}>ปริมาณสั่งเติม : {formatComma(_.get(item, 'amount', '-'))}</Tag></>}
          extra={!item.input_amount && <a onClick={() => handleAddItem(item.chemical)}>เพิ่มล็อต</a>}
        >
          <Form
            form={form}
            name="complex-form"
            style={{ width: '100%'}}
            layout="vertical"
            initialValues={{
              [item.chemical] : [{ stock: null, lot: null, amount : Number(_.get(item, 'amount', 0))}]
            }}
            >
              <Form.List 
                name={item.chemical}
              >
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <>
                      <Space
                        key={key}
                        style={{
                          display: 'flex',
                        }}
                        align="baseline"
                      >
                        <Form.Item
                          {...restField}
                          name={[name, 'stock']}
                          label={'แทงก์สารเคมี'}
                          style={{ marginRight : 6}}
                        >
                          <Select
                            allowClear
                            onClear={(value, option) => {
                              const data = form.getFieldValue(item.chemical)
                              form.setFieldValue('meter' , null)
                              data[name] = {...data[name], stock: null, lot: null, meter: null, has_meter: false}
                              form.setFieldValue(item.chemical, data);
                            }}
                            placeholder="แทงก์สารเคมี" 
                            options={_.filter(chemicalTankOptions, {chemical_name :  item.chemical})} 
                            style={{ width: 230 }} 
                            showSearch
                            onSearch={debounceTank}
                            filterOption={false}
                            onSelect={(value, option) => {
                              const data = form.getFieldValue(item.chemical)
                              data[name] = {...data[name], stock: value, lot: value, has_meter: option.has_meter, meter : null}
                              form.setFieldValue(item.chemical, data);
                            }}
                            disabled={item.input_amount ? true : false}/>
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, 'lot']}
                          label={'ล็อตสารเคมี'}
                          style={{ marginRight : 6}}
                        >
                          <Select
                            allowClear
                            onClear={() => {
                              const data = form.getFieldValue(item.chemical)
                              data[name] = {...data[name], stock: null, lot: null, meter: null, has_meter: false }
                              form.setFieldValue(item.chemical, data);
                            }}
                            placeholder="ล็อตสารเคมี" 
                            options={_.filter(chemicalLotOptions, {chemical_name : item.chemical})} 
                            style={{ width: 230}} 
                            disabled={item.input_amount ? true : false}
                            showSearch
                            filterOption={false}
                            onSearch={debounceLot}
                            onSelect={(value, option) => {
                              const data = form.getFieldValue(item.chemical)
                              data[name] = {...data[name], stock: value, lot: value, has_meter: option.has_meter, meter : null}
                              form.setFieldValue(item.chemical, data);
                            }}
                          />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, 'meter']}
                          label={'มิเตอร์'}
                          style={{ marginRight : 6}}
                          rules={[
                            {
                              required: (form.getFieldValue(item.chemical)[name].has_meter ? true : false),
                              message: 'กรุณาเลือกมิเตอร์',
                            },
                          ]}
                        >
                          <Select
                            allowClear
                            onClear={() => {
                              const data = form.getFieldValue(item.chemical)
                              data[name] = {...data[name], currentMeter : null , endMeter : null }
                              form.setFieldValue(item.chemical, data);
                            }}
                            placeholder="มิเตอร์" 
                            options={meterDropdown.options} 
                            style={{ width: 200}} 
                            disabled={form.getFieldValue(item.chemical)[name].has_meter ? item.input_amount ? true : false : true}
                            showSearch
                            filterOption={false}
                            onSearch={debounceMeter}
                            onSelect={(value, option ,index) => {
                              const data = form.getFieldValue(item.chemical)
                              data[name] = {...data[name], meter : value, currentMeter : option.current , endMeter : (Number(option.current ? option.current : 0)) + Number(form.getFieldValue(item.chemical)[name].amount ? form.getFieldValue(item.chemical)[name].amount : 0)}
                              const sameMeter = data.filter((element, idx) => element.meter === value)
                              if(sameMeter.length > 1){
                                const sumValue = sameMeter.reduce((total, obj) => total + (obj.amount || 0), 0);
                                data[name] = {...data[name], currentMeter : option.current , endMeter : (Number(option.current) + Number(sumValue))}
                              }
                              form.setFieldValue(item.chemical, data);
                            }}
                          />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, 'amount']}
                          label={'ปริมาณ'}
                          rules={[
                            {
                              required: true,
                              message: 'กรุณากรอกปริมาณ',
                            },
                          ]}
                        >
                          <InputNumber 
                            placeholder="ปริมาณ" 
                            style={{ width: 170 }} 
                            disabled={item.input_amount ? true : false}
                            onChange={(value) => {
                              const data = form.getFieldValue(item.chemical)
                              data[name] = {...data[name], amount : value}
                              const allSumValue = data.reduce((total, obj) => total + obj.amount, 0.00);
                              const sameMeter = data.filter((element, idx) => element.meter === form.getFieldValue(item.chemical)[name].meter)
                              const sumValue = sameMeter.reduce((total, obj) => total + (obj.amount || 0), 0);
                              const meter = form.getFieldValue(item.chemical)[name].meter
                              const newData = data.map((items) => {
                                console.log(Number(_.get(item, 'amount', 0)))
                                if(items.meter){
                                  if(items.meter === meter){
                                    return {...items , endMeter : toFixed(Number(items.currentMeter) + sumValue, 3), checkButton : parseFloat(allSumValue.toFixed(6)) !== Number(_.get(item, 'amount', 0))}
                                  } else {
                                    return {...items, checkButton : parseFloat(allSumValue.toFixed(6)) !== Number(_.get(item, 'amount', 0))}
                                  }
                                } else {
                                  return {...items, checkButton : parseFloat(allSumValue.toFixed(6)) !== Number(_.get(item, 'amount', 0))}
                                }
                                })
                              form.setFieldValue(item.chemical, newData);
                              console.log(parseFloat(allSumValue.toFixed(6)), Number(formatComma(_.get(item, 'amount', 0))))
                            }}/>
                        </Form.Item>
                        <Form.Item>
                          {!item.input_amount && key !== 0 && 
                          <MinusCircleOutlined onClick={() => {
                              remove(name)
                              const data = form.getFieldValue(item.chemical)
                              const newData = data.map((item) => {
                                return { ...item, meter : null, currentMeter: null, endMeter: null }
                              })
                              form.setFieldValue(item.chemical, newData);
                            }} />}
                        </Form.Item>
                      </Space>
                        {form.getFieldValue(item.chemical)[name].currentMeter && <div style={{marginBottom : 10}}>
                          มิเตอร์ :
                          <Tag color={"blue"} style={{marginLeft : 5}}>เริ่มต้น : {formatComma(form.getFieldValue(item.chemical)[name].currentMeter, 0)}, สิ้นสุด : {formatComma(form.getFieldValue(item.chemical)[name].endMeter, 0)}</Tag>
                        </div>} 
                      </>                                                                                 
                    ))}
                        {item.input_amount && <ColorButton onClick={() => handleRevertButton(item)} style={{display: 'flex', float : 'right' , marginLeft : 10, width : 90}} loading={loading}>ย้อนกลับ</ColorButton>}
                        {!item.input_amount && 
                          <ColorButton 
                            disabled={form.getFieldValue(item.chemical)[0].checkButton}
                            type="primary" 
                            override={SUCCESS_COLOR} 
                            onClick={() => handleFillButton(item.chemical, item.id)} 
                            style={{float : 'right' , marginLeft : 10, width : 80}} 
                            loading={loading}>
                              เติม
                          </ColorButton>}
                        <ReportButton 
                          hideIcon={true} 
                          url={`${URL_REPORT.LAB_INPUT_ORDER}${item.id}`}
                          style={{ float : 'right'}}
                          disabled={item.input_amount ? false : true}
                          >
                            พิมพ์
                        </ReportButton>
                      {form.getFieldValue(item.chemical)[0].checkButton && <div style={{ fontSize : 14, color : 'red', float : 'right', marginTop : 6, marginRight : 6}}> * ปริมาณสารเคมีสั่งเติมไม่ตรงกับออเดอร์จากห้องแล็บ</div>}
                  </>
                )}
              </Form.List>
          </Form>
        </Card>
        </List.Item>
        </>
    )}/>
    </>
  )
})

export default AddChemicalCard; 